var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLaw2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 571,
    viewBox: "0 0 552 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.1 183H177.2V305.6H188.1V183Z",
    fill: "#B69D8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.4 183H193.5V305.6H204.4V183Z",
    fill: "#B69D8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.7 183H209.8V305.6H220.7V183Z",
    fill: "#B69D8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9 173.6H172V179.5H225.9V173.6Z",
    fill: "#B69D8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.2 163.7H163.7V169.6H234.2V163.7Z",
    fill: "#B69D8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.948 315.45H225.848V309.55H171.948V315.45Z",
    fill: "#B69D8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.648 325.39H234.148V319.49H163.648V325.39Z",
    fill: "#B69D8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.2 183H259.3V305.6H270.2V183Z",
    fill: "#B69D8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.5 183H275.6V305.6H286.5V183Z",
    fill: "#B69D8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.8 183H291.9V305.6H302.8V183Z",
    fill: "#B69D8F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.9 173.6H254V179.5H307.9V173.6Z",
    fill: "#B69D8F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.2 163.7H245.7V169.6H316.2V163.7Z",
    fill: "#B69D8F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M254.096 315.45H307.996V309.55H254.096V315.45Z",
    fill: "#B69D8F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245.796 325.39H316.296V319.49H245.796V325.39Z",
    fill: "#B69D8F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352.3 183H341.4V305.6H352.3V183Z",
    fill: "#B69D8F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M368.5 183H357.6V305.6H368.5V183Z",
    fill: "#B69D8F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M384.8 183H373.9V305.6H384.8V183Z",
    fill: "#B69D8F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M390 173.6H336.1V179.5H390V173.6Z",
    fill: "#B69D8F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M398.3 163.7H327.8V169.6H398.3V163.7Z",
    fill: "#B69D8F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336.144 315.45H390.044V309.55H336.144V315.45Z",
    fill: "#B69D8F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M327.844 325.39H398.344V319.49H327.844V325.39Z",
    fill: "#B69D8F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281 100.8L144.7 157.1H411.3L281 100.8ZM281 145.6C273.5 145.6 267.4 139.5 267.4 132C267.4 124.5 273.5 118.4 281 118.4C288.5 118.4 294.6 124.5 294.6 132C294.6 139.5 288.5 145.6 281 145.6Z",
    fill: "#B69D8F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8 330.1H157.2V338.2H404.8V330.1Z",
    fill: "#B69D8F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M411.3 343H150.8V351.1H411.3V343Z",
    fill: "#B69D8F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 26.3001C111.7 37.3001 114.6 45.9001 121.6 50.2001C132.2 43.9001 141.9 34.9001 147.7 24.7001C153.4 14.5001 153.2 5.4001 146.7 0.100098C133.2 5.1001 121.3 15.3001 116.5 26.3001Z",
    fill: "#B69D8F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 11.4001C156.8 17.6001 148.1 27.8001 146 37.0001C155.4 39.0001 167.5 37.0001 179.8 31.4001C192.1 25.8001 202.3 17.7001 207.6 9.10011C198.4 4.90011 183.9 5.20009 170.4 11.4001Z",
    fill: "#B69D8F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.8 66.9001C136.4 67.1001 128.5 62.8001 125.7 55.2001C133.9 46.4001 146.4 40.7001 157.6 41.2001C168.8 41.7001 175.5 47.8001 176.9 55.7001C168 62.3001 157.3 66.7001 146.8 66.9001Z",
    fill: "#B69D8F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9003 59.6001C76.5003 71.1001 81.1002 79.0001 88.6002 82.0001C97.5002 74.2001 105 63.8001 108.3 53.0001C111.5 42.2001 109.4 33.4 102.2 29.3C90.4003 36.4 81.2003 48.2001 78.9003 59.6001Z",
    fill: "#B69D8F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M116.1 94.1C106.2 96 97.8 93.2 93.5 86.2C99.6 76.3 110.4 68.7 121.1 67.4C131.8 66 139.4 70.9 142.5 78.3C135.4 86.2 126.1 92.2 116.1 94.1Z",
    fill: "#B69D8F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0999 98.3001C48.9999 109.9 54.8999 116.8 62.7999 118.4C69.9999 109.3 75.1999 97.9001 76.1999 86.9001C77.1999 75.9001 73.3999 67.7001 65.5999 64.9001C55.7999 73.7001 49.1999 86.8001 49.0999 98.3001Z",
    fill: "#B69D8F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9004 125.6C82.6004 129.1 73.9004 127.8 68.4004 121.7C72.5004 111.1 81.5004 101.8 91.5004 98.8001C101.6 95.7001 109.8 99.2001 114.2 105.9C109 114.7 101.2 122.1 91.9004 125.6Z",
    fill: "#B69D8F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3003 141.1C29.3003 152.4 36.3003 158.2 44.3003 158.5C49.7003 148.3 52.8003 136.4 51.7003 125.4C50.6003 114.5 45.4003 107.1 37.2003 105.7C29.4003 116 25.3003 129.8 27.3003 141.1Z",
    fill: "#B69D8F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1003 160.5C65.7003 165.5 56.8004 165.7 50.4004 160.7C52.5004 149.6 59.6004 139.1 68.8004 134.4C78.0004 129.7 86.7004 131.7 92.3004 137.5C88.9004 146.9 82.6003 155.5 74.1003 160.5Z",
    fill: "#B69D8F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 186.7C17.3 197.5 25.0999 201.9 33.0999 200.8C36.6999 189.9 37.6 177.6 34.7 167.1C31.7 156.6 25.2 150.3 17 150.3C11.1 161.7 9.49999 176 13.4 186.7Z",
    fill: "#B69D8F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8 197.7C55.4 204.1 46.7 205.8 39.5 202C39.7 190.7 44.8 179.2 53.1 173C61.3 166.8 70.2 167.3 76.7 172C75 181.9 70.2 191.3 62.8 197.7Z",
    fill: "#B69D8F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40001 233.9C13 243.8 21.5 246.8 29.2 244.4C30.9 233 29.8 220.8 25.1 211C20.4 201.2 12.9 196.1 4.90001 197.6C1.00001 209.8 1.80001 224.1 7.40001 233.9Z",
    fill: "#B69D8F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9002 236.2C51.6002 243.7 43.4002 246.9 35.7002 244.5C34.0002 233.4 37.2002 221.2 44.2002 213.7C51.3002 206.2 60.1002 205.1 67.2002 208.6C67.3002 218.5 64.2002 228.6 57.9002 236.2Z",
    fill: "#B69D8F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40013 281.5C16.6001 290.3 25.5001 291.8 32.6001 288C32.4001 276.5 29.3001 264.7 23.0001 255.8C16.7001 247 8.5001 243.3 0.800098 246.1C-0.999902 258.8 2.20013 272.7 9.40013 281.5Z",
    fill: "#B69D8F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5002 274.9C54.6002 283.4 47.0002 288 39.0002 286.9C35.5002 276.2 36.6002 263.6 42.3002 255C48.0002 246.4 56.5002 243.8 64.1002 246C65.8002 255.9 64.4002 266.4 59.5002 274.9Z",
    fill: "#B69D8F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2003 328.1C27.8003 335.6 36.8003 335.5 43.2003 330.5C41.1003 319.1 36.0003 308 28.3003 300.3C20.7003 292.7 12.0003 290.5 4.80029 294.6C5.20029 307.4 10.7003 320.7 19.2003 328.1Z",
    fill: "#B69D8F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5001 312.9C64.1001 322.2 57.4001 328 49.3001 328.3C44.0001 318.3 43.0001 305.7 47.2001 296.3C51.4001 286.8 59.3001 282.8 67.2001 283.6C70.5001 293 70.9001 303.6 67.5001 312.9Z",
    fill: "#B69D8F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37 372.5C46.8 378.4 55.7 376.8 61.1 370.8C57 359.9 50 349.8 41.1 343.5C32.3 337.3 23.3 336.6 17 341.9C19.5 354.5 27.2 366.6 37 372.5Z",
    fill: "#B69D8F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M82 349.1C80.3 358.9 74.7 365.9 66.8 367.5C59.8 358.5 56.5999 346.2 59.0999 336.1C61.5999 325.9 68.8 320.6 76.7 320.1C81.4 328.9 83.7 339.3 82 349.1Z",
    fill: "#B69D8F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7002 413.4C73.5002 417.6 82.1002 414.5 86.3002 407.5C80.1002 397.4 71.3002 388.5 61.4002 383.9C51.5002 379.3 42.6002 380.1 37.2002 386.5C42.0002 398.6 51.9002 409.3 62.7002 413.4Z",
    fill: "#B69D8F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.9 382.5C103 392.5 98.9001 400.4 91.3001 403.4C82.6001 395.7 77.1001 384.1 77.8001 373.6C78.4001 363.1 84.6001 356.6 92.3001 354.7C98.6001 362.5 102.8 372.4 102.9 382.5Z",
    fill: "#B69D8F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3002 449.7C108 452 116 447.4 118.8 439.8C110.5 430.8 100 423.5 89.2002 420.6C78.5002 417.7 69.7002 420.1 65.7002 427.3C72.6002 438.5 84.6002 447.4 96.3002 449.7Z",
    fill: "#B69D8F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.3 412C132.5 421.9 129.9 430.5 122.9 434.8C112.6 428.7 104.8 418 103.4 407.5C102 397 106.9 389.5 114.2 386.2C122 392.9 128.1 402.1 130.3 412Z",
    fill: "#B69D8F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M137.8 480C150.2 480.3 157.4 474.4 158.5 466.4C148 458.9 135.8 453.4 124.3 452.4C112.9 451.3 104.6 455.2 102 463.1C111.4 472.9 125.5 479.7 137.8 480Z",
    fill: "#B69D8F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 436.7C168.6 446.2 167.9 455.1 161.7 460.6C149.8 456.2 139.6 447 136 436.8C132.4 426.6 135.7 418.3 142.4 413.8C151.6 419.1 159.7 427.2 164.2 436.7Z",
    fill: "#B69D8F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M187.2 503C200.1 501.2 206.2 494.1 205.5 485.9C192.8 480.2 179 476.9 166.9 477.7C155 478.6 147.4 483.9 146.5 492.1C158.4 500.4 174.4 504.9 187.2 503Z",
    fill: "#B69D8F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 455.5C211.3 464.2 212.7 473.2 207.5 479.7C194.1 477.4 181.5 469.9 175.5 460.4C169.5 450.9 171.1 442 176.9 436.5C187.4 440.2 197.7 446.8 204.5 455.5Z",
    fill: "#B69D8F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M205.6 485.9C205.6 485.9 341.7 503.3 375.9 563.2L359 571C359 571 334.2 510.3 195.5 489.1L205.6 485.9Z",
    fill: "#B69D8F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M435.5 26.3001C440.3 37.3001 437.4 45.9001 430.4 50.2001C419.8 43.9001 410.1 34.9001 404.3 24.7001C398.6 14.5001 398.8 5.4001 405.3 0.100098C418.8 5.1001 430.7 15.3001 435.5 26.3001Z",
    fill: "#B69D8F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M381.6 11.4001C395.2 17.6001 403.9 27.8001 406 37.0001C396.6 39.0001 384.5 37.0001 372.2 31.4001C359.9 25.8001 349.7 17.7001 344.4 9.10011C353.6 4.90011 368.1 5.20009 381.6 11.4001Z",
    fill: "#B69D8F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M405.2 66.9001C415.6 67.1001 423.5 62.8001 426.3 55.2001C418.1 46.4001 405.6 40.7001 394.4 41.2001C383.2 41.7001 376.5 47.8001 375.1 55.7001C384 62.3001 394.7 66.7001 405.2 66.9001Z",
    fill: "#B69D8F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M473.1 59.6001C475.5 71.1001 470.9 79.0001 463.4 82.0001C454.5 74.2001 447 63.8001 443.7 53.0001C440.5 42.2001 442.6 33.4 449.8 29.3C461.6 36.4 470.8 48.2001 473.1 59.6001Z",
    fill: "#B69D8F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M435.9 94.1C445.8 96 454.2 93.2 458.5 86.2C452.4 76.3 441.6 68.7 430.9 67.4C420.2 66 412.6 70.9 409.5 78.3C416.6 86.2 425.9 92.2 435.9 94.1Z",
    fill: "#B69D8F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M502.9 98.3001C503 109.9 497.1 116.8 489.2 118.4C482 109.3 476.8 97.9001 475.8 86.9001C474.8 75.9001 478.6 67.7001 486.4 64.9001C496.2 73.7001 502.8 86.8001 502.9 98.3001Z",
    fill: "#B69D8F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M460.1 125.6C469.4 129.1 478.1 127.8 483.6 121.7C479.5 111.1 470.5 101.8 460.5 98.8001C450.4 95.7001 442.2 99.2001 437.8 105.9C443 114.7 450.8 122.1 460.1 125.6Z",
    fill: "#B69D8F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M524.7 141.1C522.7 152.4 515.7 158.2 507.7 158.5C502.3 148.3 499.2 136.4 500.3 125.4C501.4 114.5 506.6 107.1 514.8 105.7C522.6 116 526.7 129.8 524.7 141.1Z",
    fill: "#B69D8F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M477.9 160.5C486.3 165.5 495.2 165.7 501.6 160.7C499.5 149.6 492.4 139.1 483.2 134.4C474 129.7 465.3 131.7 459.7 137.5C463.1 146.9 469.4 155.5 477.9 160.5Z",
    fill: "#B69D8F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M538.6 186.7C534.7 197.5 526.9 201.9 518.9 200.8C515.3 189.9 514.4 177.6 517.3 167.1C520.3 156.6 526.8 150.3 535 150.3C540.9 161.7 542.5 176 538.6 186.7Z",
    fill: "#B69D8F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M489.2 197.7C496.6 204.1 505.3 205.8 512.5 202C512.3 190.7 507.2 179.2 498.9 173C490.7 166.8 481.8 167.3 475.3 172C477 181.9 481.8 191.3 489.2 197.7Z",
    fill: "#B69D8F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M544.6 233.9C539 243.8 530.5 246.8 522.8 244.4C521.1 233 522.2 220.8 526.9 211C531.6 201.2 539.1 196.1 547.1 197.6C551 209.8 550.2 224.1 544.6 233.9Z",
    fill: "#B69D8F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M494.1 236.2C500.4 243.7 508.6 246.9 516.3 244.5C518 233.4 514.8 221.2 507.8 213.7C500.7 206.2 491.9 205.1 484.8 208.6C484.7 218.5 487.8 228.6 494.1 236.2Z",
    fill: "#B69D8F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M542.6 281.5C535.4 290.3 526.5 291.8 519.4 288C519.6 276.5 522.7 264.7 529 255.8C535.3 247 543.5 243.3 551.2 246.1C553 258.8 549.8 272.7 542.6 281.5Z",
    fill: "#B69D8F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 274.9C497.4 283.4 505 288 513 286.9C516.5 276.2 515.4 263.6 509.7 255C504 246.4 495.5 243.8 487.9 246C486.2 255.9 487.6 266.4 492.5 274.9Z",
    fill: "#B69D8F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M532.8 328.1C524.2 335.6 515.2 335.5 508.8 330.5C510.9 319.1 516 308 523.7 300.3C531.3 292.7 540 290.5 547.2 294.6C546.8 307.4 541.3 320.7 532.8 328.1Z",
    fill: "#B69D8F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M484.5 312.9C487.9 322.2 494.6 328 502.7 328.3C508 318.3 509 305.7 504.8 296.3C500.6 286.8 492.7 282.8 484.8 283.6C481.5 293 481.1 303.6 484.5 312.9Z",
    fill: "#B69D8F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M515 372.5C505.2 378.4 496.3 376.8 490.9 370.8C495 359.9 502 349.8 510.9 343.5C519.7 337.3 528.7 336.6 535 341.9C532.5 354.5 524.8 366.6 515 372.5Z",
    fill: "#B69D8F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M470 349.1C471.7 358.9 477.3 365.9 485.2 367.5C492.2 358.5 495.4 346.2 492.9 336.1C490.4 325.9 483.2 320.6 475.3 320.1C470.6 328.9 468.3 339.3 470 349.1Z",
    fill: "#B69D8F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M489.3 413.4C478.5 417.6 469.9 414.5 465.7 407.5C471.9 397.4 480.7 388.5 490.6 383.9C500.5 379.3 509.4 380.1 514.8 386.5C510 398.6 500.1 409.3 489.3 413.4Z",
    fill: "#B69D8F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M449.1 382.5C449 392.5 453.1 400.4 460.7 403.4C469.4 395.7 474.9 384.1 474.2 373.6C473.6 363.1 467.4 356.6 459.7 354.7C453.4 362.5 449.2 372.4 449.1 382.5Z",
    fill: "#B69D8F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M455.7 449.7C444 452 436 447.4 433.2 439.8C441.5 430.8 452 423.5 462.8 420.6C473.5 417.7 482.3 420.1 486.3 427.3C479.4 438.5 467.4 447.4 455.7 449.7Z",
    fill: "#B69D8F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M421.7 412C419.5 421.9 422.1 430.5 429.1 434.8C439.4 428.7 447.2 418 448.6 407.5C450 397 445.1 389.5 437.8 386.2C430 392.9 423.9 402.1 421.7 412Z",
    fill: "#B69D8F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M414.2 480C401.8 480.3 394.6 474.4 393.5 466.4C404 458.9 416.2 453.4 427.7 452.4C439.1 451.3 447.4 455.2 450 463.1C440.6 472.9 426.5 479.7 414.2 480Z",
    fill: "#B69D8F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M387.8 436.7C383.4 446.2 384.1 455.1 390.3 460.6C402.2 456.2 412.4 447 416 436.8C419.6 426.6 416.3 418.3 409.6 413.8C400.4 419.1 392.3 427.2 387.8 436.7Z",
    fill: "#B69D8F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M364.8 503C351.9 501.2 345.8 494.1 346.5 485.9C359.2 480.2 373 476.9 385.1 477.7C397 478.6 404.6 483.9 405.5 492.1C393.6 500.4 377.6 504.9 364.8 503Z",
    fill: "#B69D8F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M347.5 455.5C340.7 464.2 339.3 473.2 344.5 479.7C357.9 477.4 370.5 469.9 376.5 460.4C382.5 450.9 380.9 442 375.1 436.5C364.6 440.2 354.3 446.8 347.5 455.5Z",
    fill: "#B69D8F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M346.4 485.9C346.4 485.9 210.3 503.3 176.1 563.2L192.9 571C192.9 571 217.7 510.3 356.4 489.1L346.4 485.9Z",
    fill: "#B69D8F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaw2);
export default __webpack_public_path__ + "static/media/IconLaw2.2222a612d6205bff6c80de90c2d5b76c.svg";
export { ForwardRef as ReactComponent };